export default __webpack_public_path__ + "static/media/bnb.5a63ebbf.svg";